import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoadI15rPs = (uz: _ht.uz, pz: {
  _31r_fst: _ht.n,
  yearMth?: _ht.s,
  i1zrs1100iMnm?: _ht.n,
  lwrz?: {
    i18rs?: _ht.b,
    i1zrs?: _ht.b,
    i1z1s?: _ht.b,
    i1z4s?: _ht.b,
  },
}) => {
  return { // als の変更は全体に影響があるため注意
    tgt: 'i15rs',
    cdn: _hmFTH.vdd(uz), // 全体共通
    lwrz: {
      i18rs: 
        pz.lwrz?.i18rs || pz.lwrz?.i1zrs  || pz.lwrz?.i1z1s || pz.lwrz?.i1z4s ? // 実績集計表
        {
          tgt: 'i18rs',
          cdn: _hmFTH.vdd(uz) + ` AND i18ri15r1f = {i15r_fst}`, // _31r_fst は i18r でなく i1zr に適用
          rlcz: {
            i15r_fst: 'i15rs._fst',
          },
          lwrz: {
            i1zrs: 
              pz.lwrz?.i1zrs  || pz.lwrz?.i1z1s || pz.lwrz?.i1z4s ?
              {
                tgt: 'i1zrs',
                cdn: _hmFTH.vdd(uz) + `
                  AND i1zr_31r1f = ${pz._31r_fst}
                  AND i1zri18r1f = {i18r_fst}
                  AND i1zrs1100i >= ${pz.i1zrs1100iMnm}
                  AND i1zrd3100s LIKE '${pz?.yearMth}%'
                `,
                rlcz: {
                  i18r_fst: 'i18rs._fst'
                },
                lwrz: {
                  i1z1s: 
                    pz.lwrz?.i1z1s ?
                    {
                      tgt: 'i1z1s',
                      cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i1z1i1zr1k = {i1zr_key}`,
                      rlcz: {
                        i1zr_key: 'i1zrs._key',
                      }
                    }
                    : undefined,
                  i1z4s: 
                    pz.lwrz?.i1z4s ?
                    {
                      tgt: 'i1z4s',
                      cdn: _hmFTH.vdd(uz, { bVsn: false }) + ` AND i1z4i1zr1k = {i1zr_key}`,
                      rlcz: {
                        i1zr_key: 'i1zrs._key',
                      }
                    }
                    : undefined,
                }
              }
              : undefined
          }
        }
        : undefined,
      } 
  };
};

export const i15z = {
  i15r: { // 団体種別
    v0: {
      itlz: {
        i15r_31r1f: -1,
        i15ra1100i: 1,
        i15ra2100i: 1,
        i15ra3100i: 300,
        i15ra4100s: '',
/*
        i15ra5110i: 1,
        i15ra5120i: 1,
        i15ra5210i: 1,
        i15ra5220i: 1,
        i15ra5310i: 1,
        i15ra5320i: 1,
*/
        i15ra6100i: 1,
        i15ra7100i: 110,
        i15ra8010i: 1,
        i15ra8012s: '00:00',
        i15ra8020i: 1,
        i15ra8110i: 1,
        i15ra8112s: '00:00',
        i15ra8120i: 1,
        i15ra8210i: 1,
        i15ra8212s: '00:00',
        i15ra8220i: 1,
        i15ra8310i: 1,
        i15ra8312s: '00:00',
        i15ra8320i: 1,
        i15ra8410i: 1,
        i15ra8412s: '00:00',
        i15ra8420i: 1,
        i15ra8510i: 1,
        i15ra8512s: '00:00',
        i15ra8520i: 1,
      },
      fldz: {
        i15r_31r1f: {
          pfx: '施設' 
        },
        i15ra1100i: {
          pfx: '利用料の有無',
          ls: [
            { key: -1, pfx: '無料', },
            { key:  1, pfx: '有料', },
          ]
        },
        i15ra2100i: {
          pfx: 'エントリー申込の可否',
          ls: [
            { key: -1, pfx: '不可', }, // 室
            { key:  1, pfx: '可', }, // 室と同時に予約
          ]
        },
        i15ra3100i: {
          pfx: '予約可能な期間',
          ls: [
            { key:  -1, pfx: ' ', },
            { key: 120, pfx: '２週間前', },
            { key: 130, pfx: '３週間前', },
            { key: 200, pfx: '当月', },
            { key: 210, pfx: '１ヶ月前', },
            { key: 220, pfx: '２ヶ月前', },
            { key: 300, pfx: '予約解禁後', },
          ]
        },
        i15ra4100s: {
          pfx: '団体名併記文言',
        },
        i15ra5110i: {
          pfx: '予約基準日（2ヶ月前）', // 廃止予定
        },
        i15ra5120i: {
          pfx: '予約可能件数（2ヶ月前）', // 廃止予定
        },
        i15ra5210i: {
          pfx: '予約基準日（1ヶ月前）', // 廃止予定
        },
        i15ra5220i: {
          pfx: '予約可能件数（1ヶ月前）', // 廃止予定
        },
        i15ra5310i: {
          pfx: '予約基準日（当月）', // 廃止予定
        },
        i15ra5320i: {
          pfx: '予約可能件数（当月）', // 廃止予定
        },
        i15ra6100i: {
          pfx: '時間帯種別',
          ls: [
            { key:  -1, pfx: ' ', },
            { key: 1, pfx: '１種', },
            { key: 2, pfx: '２種', },
          ]
        },
        i15ra7100i: {
          pfx: '外部連携区分',
          ls: [
            { key: 110, pfx: '一般利用', },
            { key: 910, pfx: '予約不可', },
            { key: 920, pfx: '個人利用', },
            { key: 930, pfx: '老福利用', },
          ]
        },
        i15ra8010i: {
          pfx: '予約基準日（当月）',
        },
        i15ra8012s: {
          pfx: '予約基準時刻（当月）',
        },
        i15ra8020i: {
          pfx: '予約可能件数（当月）',
        },
        i15ra8110i: {
          pfx: '予約基準日（1ヶ月前）',
        },
        i15ra8112s: {
          pfx: '予約基準時刻（1ヶ月前）',
        },
        i15ra8120i: {
          pfx: '予約可能件数（1ヶ月前）',
        },
        i15ra8210i: {
          pfx: '予約基準日（2ヶ月前）',
        },
        i15ra8212s: {
          pfx: '予約基準時刻（2ヶ月前）',
        },
        i15ra8220i: {
          pfx: '予約可能件数（2ヶ月前）',
        },
        i15ra8310i: {
          pfx: '予約基準日（3ヶ月前）',
        },
        i15ra8312s: {
          pfx: '予約基準時刻（3ヶ月前）',
        },
        i15ra8320i: {
          pfx: '予約可能件数（3ヶ月前）',
        },
        i15ra8410i: {
          pfx: '予約基準日（4ヶ月前）',
        },
        i15ra8412s: {
          pfx: '予約基準時刻（4ヶ月前）',
        },
        i15ra8420i: {
          pfx: '予約可能件数（4ヶ月前）',
        },
        i15ra8510i: {
          pfx: '予約基準日（5ヶ月前）',
        },
        i15ra8512s: {
          pfx: '予約基準時刻（5ヶ月前）',
        },
        i15ra8520i: {
          pfx: '予約可能件数（5ヶ月前）',
        },
      },
    },
  },
  i151: { // 予約不可の部屋
    v0: {
      itlz: {
        i151_31r1f: -1,
        i151i15r1k: -1,
        i151i10r1f: -1,
      },
      fldz: {
        i151_31r1f: {
          pfx: '施設' 
        },
        i151i15r1k: {
          pfx: '団体種別',
        },
        i151i10r1f: {
          pfx: '予約不可の部屋',
        },
      },
    },
  },
  i152: { // 予約不可の備品・駐車場
    v0: {
      itlz: {
        i152_31r1f: -1,
        i152i15r1k: -1,
        i152i17r1f: -1,
      },
      fldz: {
        i152_31r1f: {
          pfx: '所属組織' 
        },
        i152i15r1k: {
          pfx: '団体種別',
        },
        i152i17r1f: {
          pfx: '予約不可の備品・駐車場',
        },
      },
    },
  },
};
